const languageInput = document.querySelector("#nth-gd-navigation #language");
const languageContainer = document.querySelector(
  "#nth-gd-navigation .language",
);
window.addEventListener("load", function () {
  $(".btn__menu").on("click", function (e) {
    e.preventDefault();
    $(".group__nav").toggleClass("active");
    $(this).toggleClass("active");
  });
  $(".group__nav--link").on("click", function (e) {
    if ($(this).siblings(".group__nav--dropdown").length) {
      e.preventDefault();
      // group__nav--dropdown ke ben toggle class
      $(this).siblings(".group__nav--dropdown").toggleClass("active");
    }
  });
  // Đóng language dropdown khi click ra ngoài trên PC
  if (languageInput && languageContainer) {
    // Ngăn click bên trong container bubble ra ngoài
    languageContainer.addEventListener("click", function (event) {
      event.stopPropagation();
    });

    // Đóng dropdown khi click ra ngoài
    document.addEventListener("click", function (event) {
      if (languageInput.checked) {
        languageInput.checked = false;
      }
    });
  }
});
